import type { UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { COMMUNITY_SECURE_GLOBAL_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { addQueryParam } from 'shared/utils/add-query-param'
import { ReportTargetType } from '../types/moderation'
import { communityReportKeys } from './key-factory'

export const useModerationTargetsCount = ({
  communityPath,
  type,
}: {
  communityPath: string
  type?: ReportTargetType
}): UseQueryResult<number> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, number>({
    method: RequestMethodsEnum.get,
    badRequestHandler: () => {},
  })

  return useQuery(
    queryOptions({
      queryKey: [...communityReportKeys.targets.count(communityPath), { type: type ?? null }],
      queryFn: () => {
        const params = new URLSearchParams()
        if (type) {
          addQueryParam(params, 'type', type)
        }
        const query = params.toString()
        const url = `${COMMUNITY_SECURE_GLOBAL_PREFIX}/${communityPath}/report/moderation/targets/count${query ? `?${query}` : ''}`
        return fetcher(url)
      },
      enabled: Boolean(communityPath),
    }),
  )
}
